import { TrendingUp, TrendingDown, Minus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface TrendBadgeProps {
  value: number | null
  /** When true, a positive value is shown as red (e.g. churn rate going up = bad) */
  invertColor?: boolean
  className?: string
}

export function TrendBadge({ value, invertColor = false, className }: TrendBadgeProps) {
  if (value === null || value === undefined) return null

  const isPositive = value > 0
  const isNegative = value < 0

  // Determine colour: by default positive=green, negative=red
  // When invertColor, positive=red, negative=green
  const isGood = invertColor ? isNegative : isPositive
  const isBad = invertColor ? isPositive : isNegative

  return (
    <span
      className={cn(
        'inline-flex items-center gap-0.5 text-xs font-medium',
        isGood && 'text-green-600',
        isBad && 'text-red-600',
        !isGood && !isBad && 'text-muted-foreground',
        className
      )}
    >
      {isPositive && <TrendingUp className="h-3 w-3" />}
      {isNegative && <TrendingDown className="h-3 w-3" />}
      {!isPositive && !isNegative && <Minus className="h-3 w-3" />}
      {isPositive ? '+' : ''}{value.toFixed(1)}%
    </span>
  )
}
